// FCC Admin Portal constants
import React from 'react';
import { Translate } from 'react-localize-redux';

export const emptyFunc = () => {};

export const TABLE_COL_LEVELS = {
  DESKTOP: 0,
  TABLET_UP: 1,
  MOBILE_UP: 2,
};

export const USER_STATUS = {
  ALL: <Translate id="com_all" />,
  REGISTERED: <Translate id="com_active" />,
  INVITED: <Translate id="com_invited" />,
  INVITE_FAILED: <Translate id="com_invited_failed" />,
  TERMINATED: <Translate id="com_terminated" />,
  INCOMPLETE: <Translate id="com_incomplete" />,
  EXPIRED: <Translate id="com_invitation_expired" />,
};

export const CLIENT_VERIFICATION_STATUS = {
  VERIFIED: <Translate id="user_list.client_verification_verified" />,
  PENDING: <Translate id="user_list.client_verification_pending" />,
  MISSING_INFO: <Translate id="user_list.client_verification_missing" />,
};

export const USER_ROLE = {
  GENERAL_USER: 'GENERAL_USER',
  FCC_ADMIN: 'FCC_ADMIN',
  FIRM_ADMIN: 'FIRM_ADMIN',
};

export const TEMPLATE_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};

export const FIRM_DOMAIN_SUFFIX = '.myinvestorportal.ca';

export const ACCOUNT_TYPE_LIST = [
  { text: 'com_all', value: '' },
  { text: 'invite_user.account_type_non_registered', value: 'Non-registered' },
  { text: 'invite_user.account_type_registered_education', value: 'Registered Education' },
  { text: 'invite_user.account_type_registered_income', value: 'Registered Income' },
  { text: 'invite_user.account_type_registered_savings', value: 'Registered Savings' },
  { text: 'invite_user.account_type_tax_free_savings', value: 'Tax Free Savings' },
  { text: 'invite_user.account_type_fhsa_savings', value: 'FHSA Savings' },
];

export const USER_STATUS_LIST = [
  { text: 'com_all', value: '' },
  { text: 'com_active', value: 'REGISTERED' },
  { text: 'com_invited', value: 'INVITED' },
  { text: 'com_invited_failed', value: 'INVITE_FAILED' },
  { text: 'com_terminated', value: 'TERMINATED' },
  { text: 'com_incomplete', value: 'INCOMPLETE' },
  { text: 'com_invitation_expired', value: 'EXPIRED' },
];

// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const DOMAIN_REGEXP = /^[a-zA-Z0-9-.]{1,}$/;
export const FIRST_NAME = /^[A-Za-zÀàÇçÉéÈèÊêËëÎîÏïÔôÛûÙùÜüŸÿçœæŒ&\\.\\,\\(\\)"'-/^\s]+$/;
export const FIRST_NAME_LENGTH = /^[\S\s]{1,50}$/;
export const DISPLAY_NAME_LENGTH = /^[\S\s]{1,65}$/;
export const RRCODE_REGEXP = /^[0-9A-Za-z]{3,4}(-[0-9A-Za-z]{3,4}){0,95}$/;

export const PERMISSION_TYPE = {
  MANAGE_USER: 'MANAGE_USER',
  IMPERSONATION_USER: 'IMPERSONATION_USER',
  BULK_UPLOAD: 'BULK_UPLOAD',
  ANALYTIC_REPORT: 'ANALYTIC_REPORT',
  MANAGE_MESSAGE: 'MANAGE_MESSAGE',
  ADVISOR_TEAM: 'ADVISOR_TEAM',
  VERIFY_OWNERSHIP: 'VERIFY_OWNERSHIP',
};
export const FIRM_DISPLAYNAME_REGEXP = /^[A-Za-z0-9ÀàÇçÉéÈèÊêËëÎîÏïÔôÛûÙùÜüŸÿçœæŒ\\&\\/\\%\\_\\@\\.\\*\\,\\(\\)\\{\\}\\-\s]{0,100}$/;

export const BULKUPLOAD_STATUS_LIST = [
  { text: 'bulk_upload.inviting_in_progress', value: 'Inviting in progress' },
  { text: 'bulk_upload.invitation_contains_failure', value: 'Invitation contains failure' },
  { text: 'bulk_upload.invited_successfully', value: 'Invited successfully' },
];

export const MESSAGE_STATUS_LIST = [
  { text: 'message_list.saved', value: 'Saved' },
  { text: 'message_list.sent', value: 'Sent' },
  { text: 'message_list.deleted', value: 'Deleted' },
];

export const LANGUAGE_ENGLISH = 'en';
export const LANGUAGE_FRENCH = 'fr';

export const USERSTATUS_REGISTERED = 'REGISTERED';
export const USERSTATUS_INVITED = 'INVITED';
export const USERSTATUS_INVITE_FAILED = 'INVITE_FAILED';
export const USERSTATUS_TERMINATED = 'TERMINATED';
export const USERSTATUS_INCOMPLETE = 'INCOMPLETE';
export const USERSTATUS_EXPIRED = 'EXPIRED';

export const MONTH_LONG_LIST = [
  { text: 'com_january', value: '01' },
  { text: 'com_february', value: '02' },
  { text: 'com_march', value: '03' },
  { text: 'com_april', value: '04' },
  { text: 'com_may', value: '05' },
  { text: 'com_june', value: '06' },
  { text: 'com_july', value: '07' },
  { text: 'com_august', value: '08' },
  { text: 'com_september', value: '09' },
  { text: 'com_october', value: '10' },
  { text: 'com_november', value: '11' },
  { text: 'com_december', value: '12' },
];

export const MONTH_SHORT_LIST = [
  { text: 'com_january_short', value: '01' },
  { text: 'com_february_short', value: '02' },
  { text: 'com_march_short', value: '03' },
  { text: 'com_april_short', value: '04' },
  { text: 'com_may_short', value: '05' },
  { text: 'com_june_short', value: '06' },
  { text: 'com_july_short', value: '07' },
  { text: 'com_august_short', value: '08' },
  { text: 'com_september_short', value: '09' },
  { text: 'com_october_short', value: '10' },
  { text: 'com_november_short', value: '11' },
  { text: 'com_december_short', value: '12' },
];

export const PERMISSION_NAMES = {
  MANAGE_USER: 'user_permission.invite_users',
  IMPERSONATION_USER: 'user_permission.impersonate_portal_user',
  BULK_UPLOAD: 'user_permission.bulk_upload',
  ANALYTIC_REPORT: 'user_permission.analytics_reports',
  MANAGE_MESSAGE: 'user_permission.add_update_message',
  ADVISOR_TEAM: 'user_permission.enter_team_information',
  VERIFY_OWNERSHIP: 'user_permission.verify_user_client_ownership',
};

export const MESSAGE_LANGUAGE_LIST = [
  { text: 'message_list.language_en', value: 'EN' },
  { text: 'message_list.language_fr', value: 'FR' },
  { text: 'message_list.language_en_fr', value: 'EN,FR' },
  { text: 'message_list.language_fr_en', value: 'FR,EN' },
];

export const SPECIFIC_TEMPLATE_TYPE_LIST = [
  { text: 'white_label.registration', value: 'REGISTRATION' },
  { text: 'white_label.password_reset', value: 'CHANGE_PASSWORD' },
  { text: 'white_label.device_registration', value: 'DEVICE_REGISTER' },
  { text: 'white_label.managed_profile', value: 'CHANGE_PROFILE' },
  { text: 'white_label.new_documents', value: 'NEW_DOC_NOTIFICATION' },
];

export const SELECT_EN = 'Select';
export const SELECT_FR = 'Sélectionner';

export const LOGINTYPE_SSO = 'SSO';
export const MANULIFE_USER = 'MANULIFE';
export const MANULIFE_MPC_USER = 'MPC';
